import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { parseDate } from 'utils';
import { FILE, FORM, FILE_ID, NAME, ORIGINAL_NAME } from 'store/planning';
import Preview from 'components/GoogleCloudFilePreview';

import { getOriginName } from './utils';
import { Container, Wrapper, Label } from './styles';

const Uploading = ({ data }) => {
  const { [FILE]: fileData, [FORM]: form } = data || {};
  const label = useMemo(() => {
    const { lastname, birthday } = form?.patient || {};

    if (!(lastname && birthday)) return getOriginName(fileData?.[NAME] || fileData?.[ORIGINAL_NAME]);

    return [lastname, parseDate(birthday)].filter(Boolean).join(' ');
  }, [fileData, form?.patient]);

  if (!fileData[FILE_ID]) return null;

  return (
    <Container>
      <Wrapper key={fileData[FILE_ID]}>
        <Preview data={fileData} />
        {label && <Label>{label}</Label>}
      </Wrapper>
    </Container>
  );
};

Uploading.defaultProps = { data: null };
Uploading.propTypes = {
  data: PropTypes.shape({
    [FILE]: PropTypes.shape({
      [FILE_ID]: PropTypes.string,
      [NAME]: PropTypes.string,
      [ORIGINAL_NAME]: PropTypes.string,
    }),
    [FORM]: PropTypes.shape({
      patient: PropTypes.shape({
        lastname: PropTypes.string,
        birthday: PropTypes.string,
      }).isRequired,
    }),
  }),
};

export default Uploading;
